/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as BookmarkDefs from './defs.defs.js'

const $nsid = 'app.bsky.bookmark.getBookmarks'

export { $nsid }

/** Gets views of records bookmarked by the authenticated user. Requires authentication. */
const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    bookmarks: l.array(
      l.ref<BookmarkDefs.BookmarkView>(
        (() => BookmarkDefs.bookmarkView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
